import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RegistrationStepper from "../components/RegistrationStepper";

const RegistrationSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectTimer = setTimeout(() => {
      navigate("/pricing", { replace: true });
    }, 3000);

    return () => clearTimeout(redirectTimer);
  }, [navigate]);

  return (
    <>
      <style>{`
        .registration-success-page {
          min-height: 100vh;
          display: flex;
          align-items: stretch;
          justify-content: flex-start;
          padding: 0;
          background: linear-gradient(135deg, #4a7fc5 0%, #3a9ea8 50%, #38b89c 100%);
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
        }

        .registration-success-sidebar {
          width: 250px;
          min-width: 250px;
          flex-shrink: 0;
          display: flex;
        }

        .registration-success-main {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px;
        }

        .registration-success-card {
          width: 100%;
          max-width: 480px;
          padding: 36px 28px;
          text-align: center;
          background: #ffffff;
          border-radius: 24px;
          box-shadow: 0 25px 80px rgba(15, 23, 42, 0.18);
        }

        .registration-success-icon {
          width: 82px;
          height: 82px;
          margin: 0 auto 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: linear-gradient(135deg, #16a34a, #22c55e);
          color: #ffffff;
          font-size: 44px;
          font-weight: 900;
          line-height: 1;
          box-shadow: 0 18px 35px rgba(34, 197, 94, 0.28);
        }

        .registration-success-title {
          margin: 0 0 12px;
          color: #1e293b;
          font-size: 30px;
          font-weight: 800;
        }

        .registration-success-message {
          margin: 0;
          color: #64748b;
          font-size: 16px;
          font-weight: 600;
          line-height: 1.6;
        }

        .registration-success-loader {
          width: 100%;
          height: 6px;
          margin-top: 26px;
          overflow: hidden;
          border-radius: 999px;
          background: #e2e8f0;
        }

        .registration-success-loader span {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: inherit;
          background: linear-gradient(135deg, #16a34a, #22c55e);
          animation: registration-success-progress 4s linear forwards;
          transform-origin: left;
        }

        @keyframes registration-success-progress {
          from {
            transform: scaleX(0);
          }
          to {
            transform: scaleX(1);
          }
        }

        @media (max-width: 900px) {
          .registration-success-main {
            padding: 20px 14px;
          }
        }

        @media (max-width: 480px) {
          .registration-success-card {
            padding: 32px 22px;
            border-radius: 20px;
          }

          .registration-success-title {
            font-size: 26px;
          }
        }
      `}</style>

      <main className="registration-success-page">
        <div className="registration-success-sidebar signup-stepper-desktop">
          <RegistrationStepper activeStep={2} />
        </div>
        <div className="registration-success-main">
          <section className="registration-success-card" aria-live="polite">
            <div className="registration-success-icon" aria-hidden="true">
              &#10003;
            </div>
            <h1 className="registration-success-title">Registration Successful</h1>
            <p className="registration-success-message">
              Your account has been verified successfully. Redirecting you to pricing...
            </p>
            <div className="registration-success-loader" aria-hidden="true">
              <span />
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default RegistrationSuccess;
